export const dictionaryType = [
  { id: 1, text: "Location" },
  { id: 2, text: "Pricing" },
];
